import { SpeechRecognitionHookArgs } from './speech-recognition-types';

export const useSpeechRecognition = (_args: SpeechRecognitionHookArgs) => ({
  canListen: false,
  isListening: false,
  speechVolumeStream: [],
  startRecognition: () => {},
  stopRecognition: () => {},
});
